const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class BannerCollections extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 5,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
          arrows: this.els?.arrows?.element,
        }),
        this.setOverflowing(),
      ],
    )
  }

  setOverflowing () {
    /** @param {KeenSliderInstance} carousel */
    return (carousel) => {
      const updateOverflowing = () => {
        carousel.container.setAttribute(
          'data-overflowing',
          carousel.track.details.maxIdx > 0,
        )
      }

      carousel.on('created', updateOverflowing)
      carousel.on('updated', updateOverflowing)
      carousel.on('optionsChanged', updateOverflowing)
    }
  }
}

if (!customElements.get('banner-collections')) {
  customElements.define('banner-collections', BannerCollections)
}
